// Lib
import { createSelector } from 'reselect';

// Utils
import { getAccountAge, isFeatureEnabled } from '../../../../../../common/users/utils/userPropertyUtils';
import { getHasLocaleSuggestionBeenPermanentlyDismissed } from './localeSuggestionService';
import { getSuggestedLocaleFromBrowser } from '../../../../../utils/browserLanguageUtils';

// Selectors
import { getCurrentUser } from '../../../../currentUserSelector';

// Constants
import { ExperimentId } from '../../../../../../common/experiments/experimentsConstants';
import { TIMES } from '../../../../../../common/utils/timeUtil';

const isUserOldEnough = (user: any): boolean => {
    const accountAge = getAccountAge(user);
    if (accountAge < 0) return false;

    return accountAge > TIMES.WEEK;
};

export const getLocaleAlreadySuggestedThisSession = (state: any) =>
    state.getIn(['app', 'popup', 'localeSuggestion', 'alreadySuggestedThisSession']);

export const getShouldShowLocaleSuggestionPopup = createSelector(
    getCurrentUser,
    getLocaleAlreadySuggestedThisSession,
    (currentUser, localeAlreadySuggested) => {
        // Feature flag: only show when experiment is enabled for this user
        if (!isFeatureEnabled(ExperimentId.showSpanishLocaleSuggestion, currentUser)) return false;

        // Don't show if already suggested this session (prevents duplicate in same session)
        if (localeAlreadySuggested) return false;

        // Don't show if permanently dismissed
        if (getHasLocaleSuggestionBeenPermanentlyDismissed()) return false;

    // Only show to users whose browser language matches a supported non-default app language
    if (!getSuggestedLocaleFromBrowser()) return false;

    // Only show to users who signed up more than 1 week ago
    if (!isUserOldEnough(currentUser)) return false;

    return true;
});
